import { useState } from "react";

const useReOrderLevelCalculation = () => {
    const [minimumReOrderLevel, setMinimumReOrderLevel] = useState(0);

    // Function to calculate ReOrder Level
    const calculateReOrderLevel = async (leadTimeDemand, safetyStock) => {
        const demand = parseFloat(leadTimeDemand) || 0;
        const stock = parseFloat(safetyStock) || 0;
        
        setMinimumReOrderLevel(demand + stock);
    };

    return {
        minimumReOrderLevel, 
        setMinimumReOrderLevel,
        calculateReOrderLevel
    };
};

export default useReOrderLevelCalculation;
